import React, { useEffect, useState } from "react";
import { Typography, Paper, Collapse, IconButton, Grid } from "../../components/ui";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from "../../components/icons";
import axiosInstance from "../../axios/axiosInstance";
import { toast } from "react-toastify";

const groupByNode = (data: any) => {
  const grouped: Record<number, { node_name: string; cameras: any }> = {};
  data.forEach((cam: any) => {
    const nodeId = cam.node.id;
    if (!grouped[nodeId]) {
      grouped[nodeId] = { node_name: cam.node.node_name, cameras: [] };
    }
    grouped[nodeId].cameras.push(cam);
  });
  return grouped;
};

export default function Camera() {
  const [data, setData] = useState<any>([]);
  const [openNodes, setOpenNodes] = useState<Record<string, boolean>>({});

  const toggleNode = (nodeId: string) => {
    setOpenNodes((prev) => ({ ...prev, [nodeId]: !prev[nodeId] }));
  };

  const handlegetCamera = async () => {
    try {
      const resp: any = await axiosInstance.get("/api/camera");
      if (resp.status === 200) {
        setData(groupByNode(resp?.data?.data));
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handlegetCamera();
  }, []);

  return (
    <Grid container p={2} px={{ md: 10, xs: 5 }}>
      <Grid size={12}>
        <Typography fontSize={20} fontWeight={500} color="#111827">
          Camera & Nodes
        </Typography>
      </Grid>
      <Grid container size={12} mt={2} spacing={1}>
        {Object.entries(data)?.map(([nodeId, { node_name, cameras }]: any) => (
          <Grid size={12} key={nodeId}>
            <Grid
              px={1}
              bgcolor={"#111827"}
              borderRadius={1}
              color={"whitesmoke"}
              container
              display={"flex"}
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontSize={17} fontWeight={500}>
                <IconButton onClick={() => toggleNode(nodeId)}>
                  {openNodes[nodeId] ? (
                    <ExpandLessIcon sx={{ color: "whitesmoke" }} />
                  ) : (
                    <ExpandMoreIcon sx={{ color: "whitesmoke" }} />
                  )}
                </IconButton>
                {node_name}
              </Typography>
            </Grid>
            <Collapse in={openNodes[nodeId]} timeout="auto" unmountOnExit>
              <Grid
                container
                spacing={2}
                // bgcolor={"#111827"}
                borderRadius={1}
                // color={"whitesmoke"}
                px={2}
                py={1}
                mt={0.2}
              >
                <Grid size={3}>
                  <strong>Camera ID</strong>
                </Grid>
                <Grid size={3}>
                  <strong>Label</strong>
                </Grid>
                <Grid size={3}>
                  <strong>Index</strong>
                </Grid>
              </Grid>
              {cameras?.map((cam: any) => (
                <Grid
                  container
                  spacing={2}
                  px={2}
                  py={0.3}
                  key={cam?.id}
                  // borderBottom={"1px solid #111827"}
                >
                  <Grid size={3}>{cam.cam_id}</Grid>
                  <Grid size={3}>{cam.label}</Grid>
                  <Grid size={3}>{cam.index}</Grid>
                </Grid>
              ))}
            </Collapse>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
